<template>
  <div>
    <!-- <div v-if="!imageData.name" :class="imageData.divClass"> -->
    <div :class="imageData.divClass">
      <div v-for="(item, order) in imageData.value" :key="order">
        <img
          :src="item.link"
          :height="imageData.style.height"
          :width="imageData.style.width"
          :class="imageData.style.class"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- <div v-else :class="imageData.divClass">
      <div :class="imageData.style.divClassFirst">
        {{ imageData.name }}
      </div>
      <div :class="imageData.style.divClassSecond">
        <div v-for="(item, order) in imageData.value" :key="order">
          <img
            :src="item.link"
            :height="imageData.style.height"
            :width="imageData.style.width"
            :class="imageData.style.class"
            alt=""
          />
        </div>
      </div>
    </div> 
  </div>-->
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  props: {
    imageData: {
      type: Object
    }
  }
};
</script>

<style lang="scss"></style>
